import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { labelerUserAccount } from '../../helpers/utils';

// eslint-disable-next-line react/prop-types
const ItemCard = ({ title, description, route }) => {
  const navigate = useNavigate();
  return (
    <Card sx={{ minWidth: 275, cursor: 'pointer' }} onClick={() => navigate(route)}>
      <CardContent>
        <CardHeader title={title} subheader={description}/>
      </CardContent>
    </Card>
  );
};

const Dashboard = () => {
  const {
    sessionDetails,
  } = useSelector((state) => state.auth);
  const nonAdminUser = labelerUserAccount(sessionDetails);

  return (
    <div>
      <Box
        sx={{
          textAlign: 'center',
          marginBottom: '2rem',
        }}
      >
        <h1>Dashboard</h1>
      </Box>
      <Stack direction="row" spacing={2} sx={{ marginTop: '3rem' }}>
        {
          nonAdminUser ? null : (
            <>
              <ItemCard title={'Devices'} description={'View Device Info'} route={'/device-list'}/>
              <ItemCard title={'Users'} description={'View User Info'} route={'/users'}/>
            </>
          )
        }

        <ItemCard title={'Ground Truth Updates'} description={'Ground Truth Updates'} route={'/ground-truth-updates'}/>
      </Stack>
      <Stack direction="row" spacing={2} sx={{ marginTop: '3rem' }}>
        {
          nonAdminUser ? (
            <ItemCard
              title={'Pose Estimation Labeling'}
              description={'Pose Estimation Labeling job'}
              route={'/pose-estimation-labeling'}
            />
          ) : (
            <>
              <ItemCard
                title={'Pose Estimation Labeling Review'}
                description={'Pose Estimation Labeling job review'}
                route={'/pose-estimation-labeling-review'}
              />
              <ItemCard
                title={'Pose Estimation Labeling Verify'}
                description={'Verify 75 randomly selected Pose Estimation Classifications for each type'}
                route={'/pose-estimation-labeling-verify'}
              />
            </>
          )
        }

      </Stack>
    </div>
  )
  ;
};

export default Dashboard;
